const UPDATES = [
  {
    id: 1,
    date: '2026-07-31',
    title: '《流浪地球3》超清版正式上线',
    summary: '国产科幻巨制第三部高清资源已入库，多线路切换流畅播放，支持4K杜比视界。',
    tag: '新片上线',
  },
  {
    id: 2,
    date: '2026-07-30',
    title: '暑期档专题页全新改版上线',
    summary: '焦点专题模块升级，新增智能推荐算法，根据观影偏好精准匹配你可能喜欢的影片。',
    tag: '功能更新',
  },
  {
    id: 3,
    date: '2026-07-29',
    title: '8090经典港片修复计划第三期完成',
    summary: '新增50部高清修复港片，包括《英雄本色》《重庆森林》等经典，画质提升至1080P。',
    tag: '片库扩充',
  },
  {
    id: 4,
    date: '2026-07-28',
    title: 'CDN节点全面升级，观影速度提升40%',
    summary: '全国新增12个加速节点，偏远地区用户也能享受秒加载的不缓冲观影体验。',
    tag: '体验优化',
  },
  {
    id: 5,
    date: '2026-07-26',
    title: '豆瓣年度评分最高外语片合集上线',
    summary: '精选2025-2026年豆瓣评分8.0以上的外语佳作，含获奖作品与口碑神作。',
    tag: '精选合集',
  },
  {
    id: 6,
    date: '2026-07-24',
    title: '手机端观影体验全面优化',
    summary: '移动端界面重新设计，支持手势控制亮度音量，小屏也能享受沉浸式观影。',
    tag: '移动优化',
  },
  {
    id: 7,
    date: '2026-07-22',
    title: '奥斯卡历届最佳影片全收录',
    summary: '从1929年至今所有奥斯卡最佳影片高清合集，电影史上的每一座丰碑都值得重温。',
    tag: '经典合集',
  },
  {
    id: 8,
    date: '2026-07-20',
    title: '纪录片频道独立上线',
    summary: '涵盖自然、历史、科技、人文四大板块，BBC、国家地理等顶级纪录片资源一站畅享。',
    tag: '新频道',
  },
  {
    id: 9,
    date: '2026-07-18',
    title: '8090影院注册影迷突破500万',
    summary: '感谢每一位影迷的支持与信赖，我们将持续提供电影无广告的纯净观影体验。',
    tag: '里程碑',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            最新快讯
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            紧跟8090影院最新动态，新片上线、功能升级、片库扩充，不错过任何精彩更新
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-[11px] md:left-[15px] top-2 bottom-2 w-px bg-gradient-to-b from-primary-500/40 via-accent-500/30 to-transparent"></div>

            {UPDATES.map((item, idx) => (
              <div key={item.id} className="relative pb-8 last:pb-0">
                <div className="absolute left-[-33px] md:left-[-41px] top-1.5 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full bg-background-50 border-2 border-primary-500 ring-4 ring-background-50 z-10"></div>

                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                  <span className="text-xs text-foreground-400 whitespace-nowrap font-mono">{item.date}</span>
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-2 mb-1.5">
                      <h3 className="text-sm font-semibold text-foreground-800">{item.title}</h3>
                      <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-accent-500/15 text-accent-400 border border-accent-500/20 whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.summary}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}